{
  "Accessibility Menu": "पहुँचियोग्यता मेनू",
  "Reset settings": "सेटिंग रीसेट करें",
  "Close": "बंद करें",
  "Content Adjustments": "सामग्री समायोजन",
  "Adjust Font Size": "फ़ॉन्ट आकार समायोजित करें",
  "Highlight Title": "शीर्षक को हाइलाइट करें",
  "Highlight Links": "लिंक को हाइलाइट करें",
  "Readable Font": "पढ़ने योग्य फ़ॉन्ट",
  "Color Adjustments": "रंग समायोजन",
  "Dark Contrast": "अंधेरा विरोध",
  "Light Contrast": "प्रकाश विरोध",
  "High Contrast": "उच्च विरोध",
  "High Saturation": "उच्च संतुलन",
  "Low Saturation": "निम्न संतुलन",
  "Monochrome": "एकरंग",
  "Contrast": "कॉन्ट्रास्ट",
  "Invert Colors": "रंग उलटें",
  "Tools": "उपकरण",
  "Reading Guide": "पढ़ने का गाइड",
  "Stop Animations": "एनिमेशन रोकें",
  "Big Cursor": "बड़ा कर्सर",
  "Increase Font Size": "फ़ॉन्ट आकार बढ़ाएँ",
  "Decrease Font Size": "फ़ॉन्ट आकार कम करें",
  "Letter Spacing": "अक्षर स्पेसिंग",
  "Line Height": "लाइन की ऊँचाई",
  "Font Weight": "फ़ॉन्ट वेट",
  "Dyslexia Font": "विविधताजनित विपथता फ़ॉन्ट",
  "Language": "भाषा",
  "Open Accessibility Menu": "एक्सेसिबिलिटी मेनू खोलें",
  "Widget Settings": "विजेट सेटिंग्स",
  "Widget Position": "विजेट स्थान",
  "Top Left": "ऊपर बायाँ",
  "Top Center": "ऊपर मध्य",
  "Top Right": "ऊपर दायाँ",
  "Center Left": "मध्य बायाँ",
  "Center Right": "मध्य दायाँ",
  "Bottom Left": "नीचे बायाँ",
  "Bottom Center": "नीचे मध्य",
  "Bottom Right": "नीचे दायाँ",
  "Screen Reader": "स्क्रीन रीडर",
  "Voice Navigation": "वॉयस नेविगेशन",
  "Custom Color": "कस्टम रंग",
  "Change the site's colors": "साइट के रंग बदलें",
  "Backgrounds": "पृष्ठभूमि",
  "Headings": "शीर्षक",
  "Contents": "सामग्री",
  "Reset colors": "रंग रीसेट करें",
  "Image Desaturation": "छवि रंग कम करें",
  "Search languages": "भाषाएँ खोजें",
  "No languages found": "कोई भाषा नहीं मिली",
  "Accessibility Profiles": "सुलभता प्रोफ़ाइल",
  "Motor Impaired": "गतिशीलता विकलांग",
  "Big cursor, voice navigation, and no animations.": "बड़ा कर्सर, वॉइस नेविगेशन और कोई एनीमेशन नहीं।",
  "Blind": "नेत्रहीन",
  "Screen reader helpers with higher contrast.": "अधिक कंट्रास्ट वाले स्क्रीन रीडर सहायक।",
  "Color Blind": "रंगांध",
  "High contrast palette with desaturated media.": "उच्च कंट्रास्ट पैलेट और मद्धिम मीडिया।",
  "Dyslexia": "डिस्लेक्सिया",
  "Friendly font, extra spacing, stronger weight.": "अनुकूल फ़ॉन्ट, अतिरिक्त अंतर और अधिक बोल्ड।",
  "Low vision": "कमज़ोर दृष्टि",
  "Dark contrast and 130% magnification.": "गहरा कंट्रास्ट और 130% ज़ूम।",
  "Cognitive & Learning": "संज्ञानात्मक और अधिगम",
  "Highlights key sections and enables voice help.": "मुख्य अनुभागों को हाइलाइट करता है और वॉइस सहायता सक्षम करता है।",
  "Seizure & Epileptic": "दौरे और मिर्गी",
  "Stops animations and desaturates imagery.": "एनीमेशन रोकता है और चित्रों को मद्धिम करता है।",
  "ADHD": "एडीएचडी",
  "Reading guide, highlighted links, calmer palette.": "पठन मार्गदर्शिका, हाइलाइट किए हुए लिंक और शांत पैलेट।",
  "Widget Size": "विजेट का आकार",
  "Default": "डिफ़ॉल्ट",
  "Medium": "मध्यम",
  "Small": "छोटा",
  "Color Blindness": "वर्णांधता",
  "Protanopia": "प्रोटानोपिया",
  "Deuteranopia": "ड्यूटेरानोपिया",
  "Tritanopia": "ट्रिटानोपिया",
  "Achromatopsia": "एक्रोमैटोप्सिया",
  "Simulates and assists users with color vision deficiencies.": "दृष्टि दोष वाले उपयोगकर्ताओं के लिए अनुकरण और सहायता करता है।"
}
